<mat-chip-listbox
  class="chip-list-fixed-height"
  aria-label="Current Filter Selections"
>
  @for (currentSelection of currentSelectionsDisplay; track currentSelection) {
  <mat-chip
    class="mat-standard-chip"
    (removed)="filterService.removeFilterSelectionByDisplay(currentSelection)"
  >
    {{ currentSelection.filterKeyLabel }}:
    {{ currentSelection.filterValueLabel }}
    <button matChipRemove>
      <mat-icon
        [attr.data-cy]="
          'chip-remove-button-' +
          currentSelection.filterKey +
          '-' +
          currentSelection.filterValue
        "
      >
        cancel
      </mat-icon>
    </button>
  </mat-chip>
  }
</mat-chip-listbox>
